function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import escapeHtml from 'escape-html';
import { SyncService, ERROR_TYPE } from './../services/SyncService';
import { endpointUrl, getRandomGuestName } from './../helpers';
import { extensionHighlight } from '../helpers/mappings';
import { createEditor, markdownit, createMarkdownSerializer, serializePlainText, loadSyntaxHighlight } from './../EditorFactory';
import { EditorContent } from 'tiptap';
import { Collaboration } from 'tiptap-extensions';
import { Keymap } from './../extensions';
import isMobile from './../mixins/isMobile';
import Tooltip from '@nextcloud/vue/dist/Directives/Tooltip';
var EDITOR_PUSH_DEBOUNCE = 200;
export default {
  name: 'EditorWrapper',
  components: {
    EditorContent: EditorContent,
    MenuBar: function MenuBar() {
      return import(
      /* webpackChunkName: "editor-rich" */
      './MenuBar');
    },
    MenuBubble: function MenuBubble() {
      return import(
      /* webpackChunkName: "editor-rich" */
      './MenuBubble');
    },
    ReadOnlyEditor: function ReadOnlyEditor() {
      return import(
      /* webpackChunkName: "editor" */
      './ReadOnlyEditor');
    },
    CollisionResolveDialog: function CollisionResolveDialog() {
      return import(
      /* webpackChunkName: "editor" */
      './CollisionResolveDialog');
    },
    GuestNameDialog: function GuestNameDialog() {
      return import(
      /* webpackChunkName: "editor-guest" */
      './GuestNameDialog');
    },
    SessionList: function SessionList() {
      return import(
      /* webpackChunkName: "editor-collab" */
      './SessionList');
    }
  },
  directives: {
    Tooltip: Tooltip
  },
  mixins: [isMobile],
  props: {
    initialSession: {
      type: Object,
      default: null
    },
    relativePath: {
      type: String,
      default: null
    },
    fileId: {
      type: Number,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: true
    },
    shareToken: {
      type: String,
      default: null
    },
    mime: {
      type: String,
      default: null
    },
    autohide: {
      type: Boolean,
      default: false
    },
    isDirectEditing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      tiptap: null,

      /** @type SyncService */
      syncService: null,
      document: null,
      sessions: [],
      currentSession: null,
      filteredSessions: {},
      dirty: false,
      initialLoading: false,
      lastSavedString: '',
      syncError: null,
      hasConnectionIssue: false,
      readOnly: true,
      forceRecreate: false,
      saveStatusPolling: null
    };
  },
  computed: {
    lastSavedStatus: function lastSavedStatus() {
      var status = this.dirtyStateIndicator ? '*' : '';

      if (!this.isMobile) {
        status += this.lastSavedString;
      }

      return status;
    },
    lastSavedStatusClass: function lastSavedStatusClass() {
      return this.syncError && this.lastSavedString !== '' ? 'error' : '';
    },
    dirtyStateIndicator: function dirtyStateIndicator() {
      return this.hasUnpushedChanges || this.hasUnsavedChanges;
    },
    lastSavedStatusTooltip: function lastSavedStatusTooltip() {
      var message = t('text', 'Last saved {lastSaved}', {
        lastSaved: this.lastSavedString
      });

      if (this.hasSyncCollission) {
        message = t('text', 'The document has been changed outside of the editor. The changes cannot be applied.');
      }

      if (this.hasUnpushedChanges) {
        message += ' - ' + t('text', 'Unpushed changes');
      }

      if (this.hasUnsavedChanges) {
        message += ' - ' + t('text', 'Unsaved changes');
      }

      return {
        content: message,
        placement: 'bottom'
      };
    },
    hasSyncCollission: function hasSyncCollission() {
      return this.syncError && this.syncError.type === ERROR_TYPE.SAVE_COLLISSION;
    },
    hasUnpushedChanges: function hasUnpushedChanges() {
      return this.dirty;
    },
    hasUnsavedChanges: function hasUnsavedChanges() {
      return this.document && this.document.lastSavedVersion < this.document.currentVersion;
    },
    backendUrl: function backendUrl() {
      var _this = this;

      return function (endpoint) {
        return endpointUrl(endpoint, !!_this.shareToken);
      };
    },
    hasDocumentParameters: function hasDocumentParameters() {
      return this.fileId || this.shareToken || this.initialSession;
    },
    isPublic: function isPublic() {
      return this.isDirectEditing || document.getElementById('isPublic') && document.getElementById('isPublic').value === '1';
    },
    isRichEditor: function isRichEditor() {
      return this.mime === 'text/markdown';
    },
    fileExtension: function fileExtension() {
      return this.relativePath ? this.relativePath.split('/').pop().split('.').pop() : 'txt';
    }
  },
  watch: {
    lastSavedStatus: function lastSavedStatus() {
      this.$refs.menubar && this.$refs.menubar.redrawMenuBar();
    }
  },
  mounted: function mounted() {
    if (this.active && this.hasDocumentParameters) {
      this.initSession();
    }

    this.$parent.$emit('update:loaded', true);
  },
  created: function created() {
    var _this2 = this;

    this.saveStatusPolling = setInterval(function () {
      _this2.updateLastSavedStatus();
    }, 2000);
    document.addEventListener('keydown', this._keyUpHandler, true);
  },
  beforeDestroy: function beforeDestroy() {
    this.close();
  },
  methods: {
    close: function close() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                document.removeEventListener('keydown', _this3._keyUpHandler, true);
                clearInterval(_this3.saveStatusPolling);

                if (!(_this3.currentSession && _this3.syncService)) {
                  _context.next = 12;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return _this3.syncService.close();

              case 6:
                _this3.currentSession = null;
                _this3.syncService = null;
                _context.next = 12;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);

              case 12:
                return _context.abrupt("return", true);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10]]);
      }))();
    },
    updateLastSavedStatus: function updateLastSavedStatus() {
      if (this.document) {
        this.lastSavedString = window.moment(this.document.lastSavedVersionTime * 1000).fromNow();
      }
    },
    initSession: function initSession() {
      var _this4 = this;

      if (!this.hasDocumentParameters) {
        this.$parent.$emit('error', 'No valid file provided');
        return;
      }

      var guestName = localStorage.getItem('nick') ? localStorage.getItem('nick') : getRandomGuestName();
      this.syncService = new SyncService({
        shareToken: this.shareToken,
        filePath: this.relativePath,
        guestName: guestName,
        forceRecreate: this.forceRecreate,
        serialize: function serialize(document) {
          if (_this4.isRichEditor) {
            var markdown = createMarkdownSerializer(_this4.tiptap.nodes, _this4.tiptap.marks).serialize(document);
            console.debug('serialized document', {
              markdown: markdown
            });
            return markdown;
          }

          var file = serializePlainText(_this4.tiptap);
          console.debug('serialized document', {
            file: file
          });
          return file;
        }
      }).on('opened', function (_ref) {
        var document = _ref.document,
            session = _ref.session;
        _this4.currentSession = session;
        _this4.document = document;
        _this4.readOnly = document.readOnly;
        localStorage.setItem('nick', _this4.currentSession.guestName);
      }).on('change', function (_ref2) {
        var document = _ref2.document,
            sessions = _ref2.sessions;

        if (_this4.document.baseVersionEtag !== '' && document.baseVersionEtag !== _this4.document.baseVersionEtag) {
          _this4.resolveUseServerVersion();

          return;
        }

        _this4.updateSessions.bind(_this4)(sessions);

        _this4.document = document;
        _this4.syncError = null;

        _this4.tiptap.setOptions({
          editable: !_this4.readOnly
        });
      }).on('loaded', function (_ref3) {
        var documentSource = _ref3.documentSource;
        _this4.hasConnectionIssue = false;
        loadSyntaxHighlight(extensionHighlight[_this4.fileExtension] ? extensionHighlight[_this4.fileExtension] : _this4.fileExtension).then(function (languages) {
          _this4.tiptap = createEditor({
            content: _this4.isRichEditor ? markdownit.render(documentSource) : '<pre>' + escapeHtml(documentSource) + '</pre>',
            onInit: function onInit(_ref4) {
              var state = _ref4.state;
              _this4.syncService.state = state;

              _this4.syncService.startSync();
            },
            onUpdate: function onUpdate(_ref5) {
              var state = _ref5.state;
              _this4.syncService.state = state;
            },
            extensions: [new Collaboration({
              // the initial version we start with
              // version is an integer which is incremented with every change
              version: _this4.document.initialVersion,
              clientID: _this4.currentSession.id,
              // debounce changes so we can save some bandwidth
              debounce: EDITOR_PUSH_DEBOUNCE,
              onSendable: function onSendable(_ref6) {
                var sendable = _ref6.sendable;

                if (_this4.syncService) {
                  _this4.syncService.sendSteps();
                }
              }
            }), new Keymap({
              'Ctrl-s': function CtrlS() {
                _this4.syncService.save();

                return true;
              }
            })],
            enableRichEditing: _this4.isRichEditor,
            languages: languages
          });

          _this4.tiptap.on('focus', function () {
            _this4.$emit('focus');
          });

          _this4.tiptap.on('blur', function () {
            _this4.$emit('blur');
          });

          _this4.syncService.state = _this4.tiptap.state;
        });
      }).on('sync', function (_ref7) {
        var steps = _ref7.steps,
            document = _ref7.document;
        _this4.hasConnectionIssue = false;

        try {
          _this4.tiptap.extensions.options.collaboration.update({
            version: document.currentVersion,
            steps: steps
          });

          _this4.syncService.state = _this4.tiptap.state;

          _this4.updateLastSavedStatus();
        } catch (e) {
          console.error('Failed to update steps in collaboration plugin', e); // TODO: we should recreate the editing session when this happens
        }

        _this4.document = document;
      }).on('error', function (error, data) {
        _this4.tiptap.setOptions({
          editable: false
        });

        if (error === ERROR_TYPE.SAVE_COLLISSION && (!_this4.syncError || _this4.syncError.type !== ERROR_TYPE.SAVE_COLLISSION)) {
          _this4.initialLoading = true;
          _this4.syncError = {
            type: error,
            data: data
          };
        }

        if (error === ERROR_TYPE.CONNECTION_FAILED && !_this4.hasConnectionIssue) {
          _this4.hasConnectionIssue = true; // FIXME: ideally we just try to reconnect in the service, so we don't loose steps

          OC.Notification.showTemporary('Connection failed, reconnecting');

          if (data.retry !== false) {
            setTimeout(_this4.reconnect.bind(_this4), 5000);
          }
        }

        if (error === ERROR_TYPE.SOURCE_NOT_FOUND) {
          _this4.initialLoading = false;

          _this4.$emit('close');

          _this4.$emit('error');
        }
      }).on('stateChange', function (state) {
        if (state.initialLoading && !_this4.initialLoading) {
          _this4.initialLoading = true;

          if (_this4.autofocus) {
            _this4.tiptap.focus('start');
          }

          _this4.$emit('ready');
        }

        if (state.hasOwnProperty('dirty')) {
          _this4.dirty = state.dirty;
        }
      });

      if (this.initialSession === null) {
        this.syncService.open({
          fileId: this.fileId,
          filePath: this.relativePath
        }).catch(function (e) {
          _this4.hasConnectionIssue = true;
        });
      } else {
        this.syncService.open({
          initialSession: this.initialSession
        }).catch(function (e) {
          _this4.hasConnectionIssue = true;
        });
      }

      this.forceRecreate = false;
    },
    resolveUseThisVersion: function resolveUseThisVersion() {
      this.syncService.forceSave();
      this.tiptap.setOptions({
        editable: !this.readOnly
      });
    },
    resolveUseServerVersion: function resolveUseServerVersion() {
      this.forceRecreate = true;
      this.reconnect();
    },
    reconnect: function reconnect() {
      var _this5 = this;

      if (this.syncService) {
        this.syncService.close().then(function () {
          _this5.syncService = null;

          _this5.tiptap.destroy();

          _this5.initSession();
        }).catch(function (e) {// Ignore issues closing the session since those might happen due to network issues
        });
      } else {
        this.syncService = null;
        this.tiptap.destroy();
        this.initSession();
      }
    },
    updateSessions: function updateSessions(sessions) {
      this.sessions = sessions.sort(function (a, b) {
        return b.lastContact - a.lastContact;
      });
      var currentSessionIds = this.sessions.map(function (session) {
        return session.userId;
      });
      var currentGuestIds = this.sessions.map(function (session) {
        return session.guestId;
      });
      var removedSessions = Object.keys(this.filteredSessions).filter(function (sessionId) {
        return !currentSessionIds.includes(sessionId) && !currentGuestIds.includes(sessionId);
      });

      for (var index in removedSessions) {
        Vue.delete(this.filteredSessions, removedSessions[index]);
      }

      for (var _index in this.sessions) {
        var session = this.sessions[_index];
        var sessionKey = session.displayName ? session.userId : session.id;

        if (this.filteredSessions[sessionKey]) {
          // update timestamp if relevant
          if (this.filteredSessions[sessionKey].lastContact < session.lastContact) {
            Vue.set(this.filteredSessions[sessionKey], 'lastContact', session.lastContact);
          }
        } else {
          Vue.set(this.filteredSessions, sessionKey, session);
        }

        if (session.id === this.currentSession.id) {
          Vue.set(this.filteredSessions[sessionKey], 'isCurrent', true);
        }
      }
    },
    _keyUpHandler: function _keyUpHandler(event) {
      var key = event.key || event.keyCode;

      if ((event.ctrlKey || event.metaKey) && !event.shiftKey && (key === 'f' || key === 70)) {
        event.stopPropagation();
        return true;
      }
    }
  }
};